import type { AccountInfo } from '@azure/msal-browser';

/**
 * Returns the same pseudonymous Entra identifier emitted by the BFF (`oid`, with `sub`
 * as the non-AAD fallback). MSAL exposes that value as localAccountId.
 */
export const getTelemetryUserId = (
  account: Pick<AccountInfo, 'localAccountId'>,
): string | null => account.localAccountId || null;
